/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.och.integration.rpc.OCHIntegrationRpc
 */

export const makeChartUrlsRpc = {
  serviceName: 'com.hubspot.och.integration.rpc.OCHIntegrationRpc',
  rpcName: 'makeChartUrls',
  auth: 'app',
  fingerprint: 'riBV8qmpzrbFLajKAITYGSPtr-nJv1Z8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const makeAccountMapUrlsRpc = {
  serviceName: 'com.hubspot.och.integration.rpc.OCHIntegrationRpc',
  rpcName: 'makeAccountMapUrls',
  auth: 'app',
  fingerprint: 'dG9FMPSHbHHfSZKSBMfOsfXeyQ2VA6ye',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchContactsRpc = {
  serviceName: 'com.hubspot.och.integration.rpc.OCHIntegrationRpc',
  rpcName: 'fetchContacts',
  auth: 'app',
  fingerprint: '2ZIOruJpzflcgKZpWViEv4f1DgIN_Xul',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};